module.exports = __webpack_public_path__ + "static/media/PHCT05.af36ed47.jpg";